module.exports = __webpack_public_path__ + "static/img/bkg.5b6729f0.png";